import { Wrench, TreePine, Fan, ShieldCheck } from 'lucide-react';

// Category VALUES are owned by the backend (`GET /api/v1/tasks/categories`,
// derived from models.enums.TaskCategory). This file maps those values to
// frontend-only presentation: icon + theme-token color. If the backend adds
// a new category, the fallback below renders it as "general" until this map
// is updated.

export const CATEGORY_STYLES = {
    systems:  { icon: Fan,         bgClass: 'bg-[var(--error-container)]',           textClass: 'text-[var(--error)]' },
    exterior: { icon: TreePine,    bgClass: 'bg-[var(--primary-container)]',         textClass: 'text-[var(--primary-container-text)]' },
    safety:   { icon: ShieldCheck, bgClass: 'bg-[var(--tertiary-fixed)]',            textClass: 'text-[var(--primary)]' },
    repair:   { icon: Wrench,      bgClass: 'bg-[var(--secondary-container)]',       textClass: 'text-[var(--secondary)]' },
    general:  { icon: Wrench,      bgClass: 'bg-[var(--bg-elevated)]',               textClass: 'text-[var(--text-main)]' },
};

export const getCategoryStyle = (task) =>
    CATEGORY_STYLES[task?.category] || CATEGORY_STYLES.general;
